var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"83555e58d314394127274310bc2999d10fac03f1"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN,
  beforeSend(event, hint) {
    const error = hint.originalException;

    // 센드버드 소켓 연결 종료 에러는 과도하게 많이 발생하기 때문에 무시한다.
    // 연결이 종료되어도 에러가 발생하지 않도록 차후 개선이 필요하다.
    if (
      typeof error === 'object' &&
      error !== null &&
      'name' in error &&
      'message' in error &&
      (error as any).name === 'SendbirdError' &&
      (error as any).message === 'Connection is closed. Please reconnect.'
    ) {
      return null;
    }

    return event;
  },
  environment: process.env.NEXT_PUBLIC_SENTRY_ENV_TAG,
  tracesSampleRate: 1.0,
  ignoreErrors: [/Request failed with status code 401/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [new Sentry.Replay()],
  release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
});
